import React from "react";
import { useTranslation } from "react-i18next";
import { PipeSeparator } from "../utils";
import { YOUTUBE_LINK, FACEBOOK_LINK } from "../config";

import "bootstrap/dist/css/bootstrap.css";

interface IFooter {
  showXlsExport?: boolean;
  showHomepageLink?: boolean;
  query?: string;
}

const Footer: React.FC<IFooter> = props => {
  const { t } = useTranslation();
  const { showXlsExport, showHomepageLink, query } = props;
  const export_link = query ? `/xls/${query}` : "xls";

  return (
    <div className="container">
      <div className="text-center text-muted mt-4">
        {showXlsExport && (
          <p className="small">
            <a href="/xls" data-cy="terms-excel-all">
              {t("Export all to XLS")}
            </a>
            <PipeSeparator />
            <a href={export_link} data-cy="terms-excel-selection">
              {t("Export selection to XLS")}
            </a>
          </p>
        )}
        <p className="small">
          <a href={YOUTUBE_LINK} data-cy="link-youtube">
            YouTube
          </a>
          <PipeSeparator />
          <a href={FACEBOOK_LINK} data-cy="link-facebook">
            Facebook
          </a>
        </p>
        <p className="small">
          {showHomepageLink && (
            <span>
              <a href="/" data-cy="link-homepage">
                {t("Return to homepage")}
              </a>
              <PipeSeparator />
            </span>
          )}
          <a href="/administration" data-cy="link-administration">
            {t("Administration")}
          </a>
        </p>
      </div>
    </div>
  );
};

export default Footer;
